export default __webpack_public_path__ + "assets/logo.417c9f9d.svg";